import { isUndefined } from 'lodash';
import { FieldRenderProps, useField } from 'react-final-form';

export interface BaseFormFieldProps {
  name: string;
  showErrorOnBlur?: boolean;
}

// This is not part of the BaseFormFieldProps because we don't want to expose this prop to the outside
type BaseFormFieldChildren = (
  isErrorState: boolean,
  fieldRenderProps: FieldRenderProps<any, HTMLElement, any>,
) => JSX.Element;

/**
 * This component encapsulate the final-form field features shared by all form fields
 */
export function BaseFormField({
  name,
  // By default we show the error when the input loses focus instead of while the user is typing
  showErrorOnBlur = true,
  children,
}: BaseFormFieldProps & { children: BaseFormFieldChildren }) {
  const field = useField(name);

  // Display error indicator when value is invalid.
  // The error indicator is on by default when user touches the input
  // but option showErrorOnFocus display the red indicator as soon there is an error
  let showErrorState = !isUndefined(field.meta.error);
  if (showErrorOnBlur) {
    showErrorState = showErrorState && field.meta.touched;
  }

  return children(showErrorState, field);
}
